import {
  GET_DISCOVERY_CATEGORIES,
  GET_DISCOVERY_CATEGORY_DETAILS,
  GET_DISCOVERY_CATEGORY_DETAILS_FAILED,
  GET_DISCOVERY_CATEGORY_DETAILS_SUCCESS,
  GET_DISCOVERY_CATEGORIES_FAILED,
  GET_DISCOVERY_CATEGORIES_SUCCESS,
  CLEANUP_DISCOVER_CATEGORY_DETAILS,
  CLEANUP_DISCOVERY_CATEGORIES,
} from './actionTypes';

const initialState = {
  categories: { data: [], total: 0 },
  categoriesLoading: true,

  categoryDetails: {},
  categoryDetailsLoading: true,
};

export default function discoverCategory(state = initialState, action) {
  switch (action.type) {
    // GET_DISCOVERY_CATEGORY_DETAILS
    case GET_DISCOVERY_CATEGORY_DETAILS:
      return {
        ...state,
        categoryDetailsLoading: true,
      };

    case GET_DISCOVERY_CATEGORY_DETAILS_SUCCESS:
      return {
        ...state,
        categoryDetailsLoading: false,
        categoryDetails: action.payload,
      };

    case GET_DISCOVERY_CATEGORY_DETAILS_FAILED:
      return {
        ...state,
        categoryDetailsLoading: false,
      };

    case CLEANUP_DISCOVER_CATEGORY_DETAILS:
      return {
        ...state,
        categoryDetailsLoading: true,
        categoryDetails: {},
      };

    // GET_DISCOVERY_CATEGORIES
    case GET_DISCOVERY_CATEGORIES:
      return {
        ...state,
        categoriesLoading: true,
      };

    case GET_DISCOVERY_CATEGORIES_SUCCESS:
      return {
        ...state,
        categoriesLoading: false,
        categories: action.payload,
      };

    case GET_DISCOVERY_CATEGORIES_FAILED:
      return {
        ...state,
        categoriesLoading: false,
      };

    case CLEANUP_DISCOVERY_CATEGORIES:
      return {
        ...state,
        categoriesLoading: true,
        categories: { data: [], total: 0 },
      };

    default: return state;
  }
}
